import { motion } from "framer-motion";
import { ArrowRight, Check, ChevronLeft, ChevronRight, ShieldCheck, X } from "lucide-react";
import { API, EASE, ARTICLE_GUIDE_SLUGS } from "./data";
import { AppointmentForm } from "./AppointmentForm";

export function AppointmentModal({ onClose }) {
  return (
    <div className="modal-backdrop" data-testid="appointment-modal">
      <motion.div className="modal" initial={{ opacity: 0, y: 40, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.5, ease: EASE }}>
        <button className="modal-close" data-testid="close-appointment-modal" onClick={onClose}><X /></button>
        <AppointmentForm onClose={onClose} />
      </motion.div>
    </div>
  );
}

export function ArticleModal({ article, onClose, onBook }) {
  const guideSlug = ARTICLE_GUIDE_SLUGS[article.title];
  return (
    <div className="modal-backdrop" data-testid="article-modal" onClick={onClose}>
      <motion.div className="modal article-modal" initial={{ opacity: 0, y: 40, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.5, ease: EASE }} onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" data-testid="close-article-modal" onClick={onClose}><X /></button>
        <div className="article-modal-body">
          <span className="eyebrow">Common symptoms</span>
          <h3 data-testid="article-modal-title">{article.title}</h3>
          <p className="article-intro">{article.intro}</p>
          <ul>{article.symptoms.map((s) => <li key={s}><Check size={14} /> {s}</li>)}</ul>
          <p className="article-note"><ShieldCheck size={14} /> {article.note}</p>
          {guideSlug && <a className="article-guide-link" data-testid="article-guide-link" href={`/conditions/${guideSlug}/`}>Read the full guide: symptoms, tests &amp; treatments <ArrowRight size={14} /></a>}
          <button className="button button-primary full" data-testid="article-modal-cta" onClick={() => { onClose(); onBook(); }}>Discuss your symptoms <ArrowRight size={16} /></button>
        </div>
      </motion.div>
    </div>
  );
}

export function GalleryLightbox({ item, index, total, onClose, onNavigate }) {
  return (
    <div className="lightbox-backdrop" data-testid="gallery-lightbox" onClick={onClose}>
      <motion.div className="lightbox-content" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.35, ease: EASE }} onClick={(e) => e.stopPropagation()}>
        <button className="modal-close lightbox-close" data-testid="lightbox-close" onClick={onClose}><X /></button>
        {item.content_type?.startsWith("video/") ? <video data-testid="lightbox-video" controls autoPlay playsInline src={`${API}/gallery/image/${item.storage_path}`} /> : <img data-testid="lightbox-image" src={`${API}/gallery/image/${item.storage_path}`} alt={item.caption} />}
        <div className="lightbox-bar">
          <span>{item.poster_id ? "" : item.caption}</span>
          <div className="lightbox-nav">
            <button data-testid="lightbox-prev" onClick={() => onNavigate((index - 1 + total) % total)}><ChevronLeft size={16} /></button>
            <span>{index + 1} / {total}</span>
            <button data-testid="lightbox-next" onClick={() => onNavigate((index + 1) % total)}><ChevronRight size={16} /></button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
